import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';

/*
  Generated class for the PdfViewerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class PdfViewerProvider {

   /** ----- Constructor ----- **/

   constructor(
      private platform: Platform,
      private file: File,
      private fileOpener: FileOpener
   ) { }


   /** ----- Public Methods ----- **/

   open(inPdfObj) {

      // if platform is cordova-available
      if (this.platform.is('cordova')) {
         // get buffer array of requested PDF file
         inPdfObj.getBuffer( buffer => {

            var blob = new Blob( [ buffer ], { type: 'application/pdf' } );

            // Save the PDF to the data Directory of our App
            this.file.writeFile( this.file.dataDirectory, 'myletter.pdf', blob, { replace: true } ).then( fileEntry => {

               // Open the PDf with the correct OS tools
               this.fileOpener.open( this.file.dataDirectory + 'myletter.pdf', 'application/pdf' );
            })
         });
      }
      else {
         // On a browser simply use download!
         inPdfObj.download();
      }

   }

}



// WEBPACK FOOTER //
// ./src/providers/pdf-viewer/pdf-viewer.ts